module.exports = __webpack_public_path__ + "static/LA-Jarritos-POP-Action-44-316686ebbc2145327c27ea37ad02d7f1.png";